import React from 'react';
import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Routes from './components/Routes';
import userPool from './userPool';
import { syncHistoryWithStore } from 'react-router-redux'
import { pullIfNeeded, pushIfNeeded} from './actions/sync';
import {syncUserEdits} from './actions/response';
import createStore from './store/createStore';
import {  browserHistory } from 'react-router';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import {IntlProvider} from 'react-intl';
import {getTranslationMessages} from "./reducer/translations"

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: "https://c1a2ed2413f445d78cbf79a209d18b3a@sentry.io/1386674"
   });
}

export const store = createStore();
window.store = store;

userPool.init(store.dispatch);

export const history = syncHistoryWithStore(browserHistory, store);

const uuidRegex = /[A-F\d]{8}-[A-F\d]{4}-4[A-F\d]{3}-[89AB][A-F\d]{3}-[A-F\d]{12}/i

history.listen(location => {
  var path = location.pathname;
  var responseID = path.match(uuidRegex);
  path = path.replace(uuidRegex, '[responseID]');
  ReactGA.set({ page: path  });
  if(responseID) { ReactGA.set({dimension1: responseID[0]})}
  ReactGA.pageview(path);
});

setInterval(() => store.dispatch(pullIfNeeded()), 10000);
setInterval(() => store.dispatch(pushIfNeeded()), 1000);
setTimeout(() => store.dispatch(pullIfNeeded()), 50);
setInterval(() => store.dispatch(syncUserEdits()), 1000);

const render = () => {
  ReactDOM.render((
    <Provider store={store}>
      <MuiThemeProvider>
        <Routes />
      </MuiThemeProvider>
    </Provider>
  ), document.getElementById("app"));
}

render();
